export const filterString = (originalString: string): string => {
  let modifiedString =
    originalString.slice(0, 4) +
    '*'.repeat(8 - 4 + 1) +
    originalString.slice(8 + 1);
  return modifiedString;
};

export const titelize = (val: string): string => {
  return val?.split('_')?.join(' ');
};

export const slugify = (text?: string): string | null => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');
};

export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatInfoValue = (value: string): string => {
  const formated = titelize(value)
    .replace(/\+/g, ' + ')
    .replace(/\s+/g, ' ')
    .trim();

  return capitalize(formated);
};

export const generateRandomString = (length: number): string => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
